<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>

<div class="text-base sm:text-lg mb-4 font-semibold">
  {{ formatReportType(currentReportType) || 'Report' }}
</div>

<form [formGroup]="formGrp" class="px-4 py-2 bg-fieldset rounded shadow-sm" (ngSubmit)="formSubmitHandler()">

  <!-- Header Row -->
  <div class="flex flex-wrap justify-between items-center border-b border-slate-400 px-2 py-2">
    <h2 class="text-base sm:text-lg font-medium">Generate Report</h2>

    <div class="flex flex-wrap gap-2 mt-2 sm:mt-0">
      <button mat-button color="primary" type="reset" (click)="onResetForm()" class="flex items-center gap-1">
        <mat-icon>refresh</mat-icon> Reset
      </button>

      <button mat-button color="primary" type="submit" class="flex items-center gap-1" [disabled]="formGrp.invalid">
        <mat-icon>assignment</mat-icon> Generate Report
      </button>
    </div>
  </div>

  <!-- Fields Grid -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4 items-start">
    <ng-container *ngFor="let f of fields">
      <ng-container *ngIf="shouldShowField(f)">
        <!-- Date Field -->
        <div *ngIf="f.type === 'date'" class="form-item">
          <mat-label class="field-label">
            <span *ngIf="isMandatory(f.name)" class="text-red-600 mr-0.5">*</span>{{ getLabel(f.label) }}
          </mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput [formControlName]="f.name" [matDatepicker]="picker" [max]="today" [min]="getMinDate(f)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Select -->
        <!-- 🔽 Searchable Select Dropdown -->
        <div *ngIf="f.type === 'select'" class="form-item">
          <mat-label class="field-label">
            <span *ngIf="f.required" class="text-red-600 mr-0.5">*</span>{{ getLabel(f.label) }}
          </mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <!-- 🔁 Custom suffix icon (spinner or arrow) -->
            <mat-icon matSuffix [ngClass]="{
                'animate-spin': loadingMap[f.name],
                'line-arrow': !loadingMap[f.name]
              }">
              {{ loadingMap[f.name] ? 'sync' : 'expand_more' }}
            </mat-icon>

            <!-- ✅ Mat-select with search -->
            <mat-select [formControlName]="f.name"
              [disabled]="f.name === 'courts' && !formGrp.get('courtDivision')?.value"
              (selectionChange)="onSelectChange(f.name, $event)" [disableOptionCentering]="true"
              panelClass="searchable-select-panel">
              <!-- Search input inside panel -->
              <mat-option class="search-option" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <input matInput type="text" placeholder="Search {{ f.label }}" autocomplete="off"
                  (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                  [value]="searchTextMap[f.name] || ''" (input)="onSearchInput(f.name, $event)"
                  class="w-full border rounded px-2 py-1 focus:outline-none" />
              </mat-option>

              <!-- Loading -->
              <mat-option *ngIf="loadingMap[f.name]" disabled>
                <mat-spinner diameter="20"></mat-spinner> Loading...
              </mat-option>

              <!-- Filtered options -->
              <mat-option *ngFor="let opt of filteredOptionsMap[f.name]" [value]="opt">
                {{ f.name === 'staffName' || f.name === 'counselName' || f.name === 'partyName1' || f.name ===
                'partyName2' || f.name === 'judge' ? (opt.value + ' — ' + opt.label) : opt.label }}
              </mat-option>

              <!-- Empty -->
              <mat-option *ngIf="!loadingMap[f.name] && filteredOptionsMap[f.name]?.length === 0" disabled>
                No options found
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="f.name === 'caseNumber'" class="form-item">
          <app-case-number-search [label]="userType === 'lawyer' ? 'Case Number' : 'Appeal Number'"
            (caseSelected)="onCaseSearchOptionSelected($event)" [formControlName]="f.name">
          </app-case-number-search>
        </div>

        <!-- Search (Autocomplete) -->
        <div *ngIf="f.type === 'search' && f.name !== 'caseNumber'" class="form-item">
          <mat-label class="field-label">
            <span *ngIf="f.required" class="text-red-600 mr-0.5">*</span>{{ getLabel(f.label) }}
          </mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput [formControlName]="f.name" placeholder="Search {{ f.label }}" [matAutocomplete]="auto" />
            <mat-icon matSuffix>search</mat-icon>

            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySearchResult.bind(this, f.label)">
              <ng-container *ngIf="getResults(f.name)?.length; else noResults">
                <mat-option *ngFor="let item of getResults(f.name)" [value]="item">
                  {{ getDisplayLabel(item) }}
                </mat-option>
              </ng-container>
              <ng-template #noResults>
                <mat-option disabled>No Results</mat-option>
              </ng-template>
            </mat-autocomplete>
          </mat-form-field>

        </div>

        <!-- Text -->
        <div *ngIf="f.type === 'text'" class="form-item">
          <mat-label class="field-label">
            <span *ngIf="f.required" class="text-red-600 mr-0.5">*</span>{{ getLabel(f.label)}}
          </mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput [formControlName]="f.name">
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
  </div>
</form>